import type { Video } from '@/types/video'

/**
 * Whether there is something to play right now.
 *
 * Not the same question as "does this page have a video". `video` is an object, so it is
 * always truthy once present, and a Bunny row that is still encoding answers `ready: false`
 * with a URL that will 404 until it finishes. The backend reports that rather than falling
 * back to the legacy S3 file on purpose — the flag is in the payload so a client can wait.
 *
 * The legacy S3 leg answers `ready: true`, because a file in a bucket has no encode to wait
 * on, so this is also what keeps unmigrated lessons playing.
 */
export const isPlayableVideo = (video?: Video | null): boolean => !!video?.url && !!video?.ready
